export const FEATURED_PRODUCTS = [
  {
    id: 3,
    name: 'Sleeveless Deana Maxi Dress',
    price: 950,
    quantity: 1,
    rating: 4.7,
    category: 'casual wear',
    thumbnails: [
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
    ],
    imageUrl:
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
  },
  {
    id: 15,
    name: 'SASSAFRAS Women Maroon Solid Tiered Maxi Dress',
    price: 1999,
    category: 'party wear',
    quantity: 1,
    rating: 4.9,
    thumbnails: [
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
    ],
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11364418/2020/1/28/8e31363f-8ac5-4669-9aa8-114d502d7be61580207577109-SASSAFRAS-Women-Maroon-Solid-Tiered-Maxi-Dress-3781580207574-1.jpg',
  },
  {
    id: 25,
    name: 'Daniel Klein Premium Women Silver-Toned Dial Watch DK11138-2s',
    price: 3999,
    category: 'accessories',
    quantity: 1,
    rating: 4.3,
    thumbnails: [
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
    ],
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1620103/2020/11/17/77ba2931-9a18-44fd-b537-a4a3833280341605623766837-Daniel-Klein-Premium-Women-Silver-Toned-Dial-Watch-DK11138-2-2.jpg',
  },
  {
    id: 39,
    name: `Crocs Unisex Navy Blue Solid Bayaband Clogs`,
    price: 2979,
    category: 'footwear',
    quantity: 1,
    rating: 4.5,
    thumbnails: [
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
    ],
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11567688/2020/3/20/1f4d4b99-8a35-48af-87da-f966a2c23b5a1584703400474-Crocs-Unisex-Navy-Blue-Sandals-2211584703399157-1.jpg',
  },
  {
    id: 3,
    name: 'Sleeveless Deana Maxi Dress',
    price: 950,
    quantity: 1,
    rating: 4.7,
    category: 'casual wear',
    thumbnails: [
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
    ],
    imageUrl:
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
  },
  {
    id: 15,
    name: 'SASSAFRAS Women Maroon Solid Tiered Maxi Dress',
    price: 1999,
    category: 'party wear',
    quantity: 1,
    rating: 4.9,
    thumbnails: [
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
    ],
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11364418/2020/1/28/8e31363f-8ac5-4669-9aa8-114d502d7be61580207577109-SASSAFRAS-Women-Maroon-Solid-Tiered-Maxi-Dress-3781580207574-1.jpg',
  },
  {
    id: 25,
    name: 'Daniel Klein Premium Women Silver-Toned Dial Watch DK11138-2s',
    price: 3999,
    category: 'accessories',
    quantity: 1,
    rating: 4.3,
    thumbnails: [
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
    ],
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1620103/2020/11/17/77ba2931-9a18-44fd-b537-a4a3833280341605623766837-Daniel-Klein-Premium-Women-Silver-Toned-Dial-Watch-DK11138-2-2.jpg',
  },
  {
    id: 39,
    name: `Crocs Unisex Navy Blue Solid Bayaband Clogs`,
    price: 2979,
    category: 'footwear',
    quantity: 1,
    rating: 4.5,
    thumbnails: [
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
    ],
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11567688/2020/3/20/1f4d4b99-8a35-48af-87da-f966a2c23b5a1584703400474-Crocs-Unisex-Navy-Blue-Sandals-2211584703399157-1.jpg',
  },
  {
    id: 3,
    name: 'Sleeveless Deana Maxi Dress',
    price: 950,
    quantity: 1,
    rating: 4.7,
    category: 'casual wear',
    thumbnails: [
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
    ],
    imageUrl:
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
  },
  {
    id: 15,
    name: 'SASSAFRAS Women Maroon Solid Tiered Maxi Dress',
    price: 1999,
    category: 'party wear',
    quantity: 1,
    rating: 4.9,
    thumbnails: [
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
    ],
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11364418/2020/1/28/8e31363f-8ac5-4669-9aa8-114d502d7be61580207577109-SASSAFRAS-Women-Maroon-Solid-Tiered-Maxi-Dress-3781580207574-1.jpg',
  },
  {
    id: 25,
    name: 'Daniel Klein Premium Women Silver-Toned Dial Watch DK11138-2s',
    price: 3999,
    category: 'accessories',
    quantity: 1,
    rating: 4.3,
    thumbnails: [
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
    ],
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1620103/2020/11/17/77ba2931-9a18-44fd-b537-a4a3833280341605623766837-Daniel-Klein-Premium-Women-Silver-Toned-Dial-Watch-DK11138-2-2.jpg',
  },
  {
    id: 39,
    name: `Crocs Unisex Navy Blue Solid Bayaband Clogs`,
    price: 2979,
    category: 'footwear',
    quantity: 1,
    rating: 4.5,
    thumbnails: [
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
    ],
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11567688/2020/3/20/1f4d4b99-8a35-48af-87da-f966a2c23b5a1584703400474-Crocs-Unisex-Navy-Blue-Sandals-2211584703399157-1.jpg',
  },
];

const CASUAL_WEAR = [
  {
    id: 1,
    name: 'Tinny Three Quarter Sleeve Dress',
    price: 750,
    category: 'casual wear',
    quantity: 1,
    rating: 4.3,
    thumbnails: [
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
    ],
    imageUrl:
      'https://cdn.iclothing.com/media/catalog/product/cache/1/thumbnail/1345x1992/9df78eab33525d08d6e5fb8d27136e95/t/i/tinny_three_quarter_sleeve_dress_in_navy_and_green_stripe-3.jpg',
  },
  {
    id: 2,
    name: 'Vila Striped T-Shirt Dress',
    price: 550,
    quantity: 1,
    rating: '3.3',
    category: 'casual wear',
    imageUrl:
      'https://i.pinimg.com/originals/7b/ac/47/7bac47bee7924bee927afaa3ef86ed2a.jpg',
  },
  {
    id: 3,
    name: 'Sleeveless Deana Maxi Dress',
    price: 950,
    quantity: 1,
    rating: 4.7,
    category: 'casual wear',
    imageUrl:
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
  },
  {
    id: 4,
    name: 'Tinny Three Quarter Sleeve Dress',
    price: 750,
    quantity: 1,
    rating: 4.3,
    category: 'casual wear',
    imageUrl:
      'https://cdn.iclothing.com/media/catalog/product/cache/1/thumbnail/1345x1992/9df78eab33525d08d6e5fb8d27136e95/t/i/tinny_three_quarter_sleeve_dress_in_navy_and_green_stripe-3.jpg',
  },
  {
    id: 5,
    name: 'Vila Striped T-Shirt Dress',
    price: 550,
    quantity: 1,
    rating: '3.3',
    category: 'casual wear',
    imageUrl:
      'https://i.pinimg.com/originals/7b/ac/47/7bac47bee7924bee927afaa3ef86ed2a.jpg',
  },
  {
    id: 6,
    name: 'Sleeveless Deana Maxi Dress',
    price: 950,
    quantity: 1,
    rating: 4.7,
    category: 'casual wear',
    imageUrl:
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
  },
  {
    id: 7,
    name: 'Tinny Three Quarter Sleeve Dress',
    price: 750,
    quantity: 1,
    rating: 4.3,
    category: 'casual wear',
    imageUrl:
      'https://cdn.iclothing.com/media/catalog/product/cache/1/thumbnail/1345x1992/9df78eab33525d08d6e5fb8d27136e95/t/i/tinny_three_quarter_sleeve_dress_in_navy_and_green_stripe-3.jpg',
  },
  {
    id: 8,
    name: 'Vila Striped T-Shirt Dress',
    price: 550,
    quantity: 1,
    rating: '3.3',
    category: 'casual wear',
    imageUrl:
      'https://i.pinimg.com/originals/7b/ac/47/7bac47bee7924bee927afaa3ef86ed2a.jpg',
  },
  {
    id: 9,
    name: 'Sleeveless Deana Maxi Dress',
    price: 950,
    quantity: 1,
    rating: 4.7,
    category: 'casual wear',
    imageUrl:
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
  },
  {
    id: 10,
    name: 'Tinny Three Quarter Sleeve Dress',
    price: 750,
    quantity: 1,
    rating: 4.3,
    category: 'casual wear',
    imageUrl:
      'https://cdn.iclothing.com/media/catalog/product/cache/1/thumbnail/1345x1992/9df78eab33525d08d6e5fb8d27136e95/t/i/tinny_three_quarter_sleeve_dress_in_navy_and_green_stripe-3.jpg',
  },
  {
    id: 11,
    name: 'Vila Striped T-Shirt Dress',
    price: 550,
    quantity: 1,
    rating: '3.3',
    category: 'casual wear',
    imageUrl:
      'https://i.pinimg.com/originals/7b/ac/47/7bac47bee7924bee927afaa3ef86ed2a.jpg',
  },
  {
    id: 12,
    name: 'Sleeveless Deana Maxi Dress',
    price: 950,
    quantity: 1,
    rating: 4.7,
    category: 'casual wear',
    imageUrl:
      'https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_210,c_limit,fl_progressive/assets/images/11364356/2020/1/24/23e82afe-b43e-49ae-b7d2-88dc53b342311579863771350-SASSAFRAS-Women-Cream-Coloured-Printed-Maxi-Dress-9231579863-3.jpg',
  },
];

const PARTY_WEAR = [
  {
    id: 13,
    name: 'SASSAFRAS Black & Pink Printed Wrap Dress',
    price: 1699,
    category: 'party wear',
    quantity: 1,
    rating: '4.1',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/10856160/2019/11/5/f0172470-408a-4b8b-a1e5-045bd98a5f8b1572938035104-SASSAFRAS-Women-Dresses-9581572938032856-1.jpg',
  },
  {
    id: 14,
    name: 'Tokyo Talkies Navy Polka Dot Belted Shirt Dress',
    price: 1249,
    category: 'party wear',
    quantity: 1,
    rating: '3.9',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2242503/2018/7/30/00fa54ff-cc59-4d9e-b618-34766946f2c81532942294504-Tokyo-Talkies-Women-Navy-Printed-Shirt-Dress-5291532942294350-1.jpg',
  },
  {
    id: 15,
    name: 'SASSAFRAS Women Maroon Solid Tiered Maxi Dress',
    price: 1999,
    category: 'party wear',
    quantity: 1,
    rating: 4.9,
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11364418/2020/1/28/8e31363f-8ac5-4669-9aa8-114d502d7be61580207577109-SASSAFRAS-Women-Maroon-Solid-Tiered-Maxi-Dress-3781580207574-1.jpg',
  },
  {
    id: 16,
    name: 'SASSAFRAS Black & Pink Printed Wrap Dress',
    price: 1699,
    category: 'party wear',
    quantity: 1,
    rating: '4.1',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/10856160/2019/11/5/f0172470-408a-4b8b-a1e5-045bd98a5f8b1572938035104-SASSAFRAS-Women-Dresses-9581572938032856-1.jpg',
  },
  {
    id: 17,
    name: 'Tokyo Talkies Navy Polka Dot Belted Shirt Dress',
    price: 1249,
    category: 'party wear',
    quantity: 1,
    rating: '3.9',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2242503/2018/7/30/00fa54ff-cc59-4d9e-b618-34766946f2c81532942294504-Tokyo-Talkies-Women-Navy-Printed-Shirt-Dress-5291532942294350-1.jpg',
  },
  {
    id: 18,
    name: 'SASSAFRAS Women Maroon Solid Tiered Maxi Dress',
    price: 1999,
    category: 'party wear',
    quantity: 1,
    rating: 4.9,
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11364418/2020/1/28/8e31363f-8ac5-4669-9aa8-114d502d7be61580207577109-SASSAFRAS-Women-Maroon-Solid-Tiered-Maxi-Dress-3781580207574-1.jpg',
  },
  {
    id: 19,
    name: 'SASSAFRAS Black & Pink Printed Wrap Dress',
    price: 1699,
    category: 'party wear',
    quantity: 1,
    rating: '4.1',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/10856160/2019/11/5/f0172470-408a-4b8b-a1e5-045bd98a5f8b1572938035104-SASSAFRAS-Women-Dresses-9581572938032856-1.jpg',
  },
  {
    id: 20,
    name: 'Tokyo Talkies Navy Polka Dot Belted Shirt Dress',
    price: 1249,
    category: 'party wear',
    quantity: 1,
    rating: '3.9',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2242503/2018/7/30/00fa54ff-cc59-4d9e-b618-34766946f2c81532942294504-Tokyo-Talkies-Women-Navy-Printed-Shirt-Dress-5291532942294350-1.jpg',
  },
  {
    id: 21,
    name: 'SASSAFRAS Women Maroon Solid Tiered Maxi Dress',
    price: 1999,
    category: 'party wear',
    quantity: 1,
    rating: 4.9,
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11364418/2020/1/28/8e31363f-8ac5-4669-9aa8-114d502d7be61580207577109-SASSAFRAS-Women-Maroon-Solid-Tiered-Maxi-Dress-3781580207574-1.jpg',
  },
  {
    id: 22,
    name: 'SASSAFRAS Black & Pink Printed Wrap Dress',
    price: 1699,
    category: 'party wear',
    quantity: 1,
    rating: '4.1',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/10856160/2019/11/5/f0172470-408a-4b8b-a1e5-045bd98a5f8b1572938035104-SASSAFRAS-Women-Dresses-9581572938032856-1.jpg',
  },
  {
    id: 23,
    name: 'Tokyo Talkies Navy Polka Dot Belted Shirt Dress',
    price: 1249,
    category: 'party wear',
    quantity: 1,
    rating: '3.9',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2242503/2018/7/30/00fa54ff-cc59-4d9e-b618-34766946f2c81532942294504-Tokyo-Talkies-Women-Navy-Printed-Shirt-Dress-5291532942294350-1.jpg',
  },
  {
    id: 24,
    name: 'SASSAFRAS Women Maroon Solid Tiered Maxi Dress',
    price: 1999,
    category: 'party wear',
    quantity: 1,
    rating: 4.9,
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11364418/2020/1/28/8e31363f-8ac5-4669-9aa8-114d502d7be61580207577109-SASSAFRAS-Women-Maroon-Solid-Tiered-Maxi-Dress-3781580207574-1.jpg',
  },
];

const ACCESSORIES = [
  {
    id: 25,
    name: 'Daniel Klein Premium Women Silver-Toned Dial Watch DK11138-2s',
    price: 3999,
    category: 'accessories',
    quantity: 1,
    rating: 4.3,
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1620103/2020/11/17/77ba2931-9a18-44fd-b537-a4a3833280341605623766837-Daniel-Klein-Premium-Women-Silver-Toned-Dial-Watch-DK11138-2-2.jpg',
  },
  {
    id: 26,
    name: 'MANGO Burgundy Solid Tote Bag',
    price: 1999,
    category: 'accessories',
    quantity: 1,
    rating: '2',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13693720/2021/2/23/8a21fdf1-4468-482c-997d-5c8c61eb87101614062857200-MANGO-Women-Handbags-2531614062855486-1.jpg',
  },
  {
    id: 27,
    name: `L'Oreal Paris Revitalift Crystal Micro-Essence Face Serum 22 ml`,
    price: 299,
    category: 'accessories',
    quantity: 1,
    rating: '4.2',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11218036/2020/2/25/0415401e-bd22-49a1-b8da-dac3d8e695771582616453483-LOreal-Women-Face-Serum-and-Gel-7301582616453356-1.jpg',
  },

  {
    id: 28,
    name: 'Daniel Klein Premium Women Silver-Toned Dial Watch DK11138-2s',
    price: 3999,
    category: 'accessories',
    quantity: 1,
    rating: 4.3,
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1620103/2020/11/17/77ba2931-9a18-44fd-b537-a4a3833280341605623766837-Daniel-Klein-Premium-Women-Silver-Toned-Dial-Watch-DK11138-2-2.jpg',
  },
  {
    id: 29,
    name: 'MANGO Burgundy Solid Tote Bag',
    price: 1999,
    category: 'accessories',
    quantity: 1,
    rating: '2',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13693720/2021/2/23/8a21fdf1-4468-482c-997d-5c8c61eb87101614062857200-MANGO-Women-Handbags-2531614062855486-1.jpg',
  },
  {
    id: 30,
    name: `L'Oreal Paris Revitalift Crystal Micro-Essence Face Serum 22 ml`,
    price: 299,
    category: 'accessories',
    quantity: 1,
    rating: '4.2',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11218036/2020/2/25/0415401e-bd22-49a1-b8da-dac3d8e695771582616453483-LOreal-Women-Face-Serum-and-Gel-7301582616453356-1.jpg',
  },

  {
    id: 31,
    name: 'Daniel Klein Premium Women Silver-Toned Dial Watch DK11138-2s',
    price: 3999,
    category: 'accessories',
    quantity: 1,
    rating: 4.3,
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1620103/2020/11/17/77ba2931-9a18-44fd-b537-a4a3833280341605623766837-Daniel-Klein-Premium-Women-Silver-Toned-Dial-Watch-DK11138-2-2.jpg',
  },
  {
    id: 32,
    name: 'MANGO Burgundy Solid Tote Bag',
    price: 1999,
    category: 'accessories',
    quantity: 1,
    rating: '2',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13693720/2021/2/23/8a21fdf1-4468-482c-997d-5c8c61eb87101614062857200-MANGO-Women-Handbags-2531614062855486-1.jpg',
  },
  {
    id: 33,
    name: `L'Oreal Paris Revitalift Crystal Micro-Essence Face Serum 22 ml`,
    price: 299,
    category: 'accessories',
    quantity: 1,
    rating: '4.2',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11218036/2020/2/25/0415401e-bd22-49a1-b8da-dac3d8e695771582616453483-LOreal-Women-Face-Serum-and-Gel-7301582616453356-1.jpg',
  },

  {
    id: 34,
    name: 'Daniel Klein Premium Women Silver-Toned Dial Watch DK11138-2s',
    price: 3999,
    category: 'accessories',
    quantity: 1,
    rating: 4.3,
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1620103/2020/11/17/77ba2931-9a18-44fd-b537-a4a3833280341605623766837-Daniel-Klein-Premium-Women-Silver-Toned-Dial-Watch-DK11138-2-2.jpg',
  },
  {
    id: 35,
    name: 'MANGO Burgundy Solid Tote Bag',
    price: 1999,
    category: 'accessories',
    quantity: 1,
    rating: '2',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13693720/2021/2/23/8a21fdf1-4468-482c-997d-5c8c61eb87101614062857200-MANGO-Women-Handbags-2531614062855486-1.jpg',
  },
  {
    id: 36,
    name: `L'Oreal Paris Revitalift Crystal Micro-Essence Face Serum 22 ml`,
    price: 299,
    category: 'accessories',
    quantity: 1,
    rating: '4.2',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11218036/2020/2/25/0415401e-bd22-49a1-b8da-dac3d8e695771582616453483-LOreal-Women-Face-Serum-and-Gel-7301582616453356-1.jpg',
  },
];

const FOOTWEAR = [
  {
    id: 37,
    name: `DressBerry Women Peach-Coloured Solid Flats`,
    price: 799,
    category: 'footwear',
    quantity: 1,
    rating: '3.2',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11564036/2020/5/26/f1f8bbc9-046a-4529-87e2-249a3c033c2c1590467165883-DressBerry-Women-Flats-2831590467165015-1.jpg',
  },
  {
    id: 38,
    name: `ZAPATOZ Women White Sneakers`,
    price: 999,
    category: 'footwear',
    quantity: 1,
    rating: '3.9',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11812038/2020/4/27/cd8f97ad-3b01-4178-ab54-bee0a962de0e1587965336877ZAPATOZ4.jpg',
  },
  {
    id: 39,
    name: `Crocs Unisex Navy Blue Solid Bayaband Clogs`,
    price: 2979,
    category: 'footwear',
    quantity: 1,
    rating: 4.5,
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11567688/2020/3/20/1f4d4b99-8a35-48af-87da-f966a2c23b5a1584703400474-Crocs-Unisex-Navy-Blue-Sandals-2211584703399157-1.jpg',
  },
  {
    id: 40,
    name: `DressBerry Women Peach-Coloured Solid Flats`,
    price: 799,
    category: 'footwear',
    quantity: 1,
    rating: '3.2',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11564036/2020/5/26/f1f8bbc9-046a-4529-87e2-249a3c033c2c1590467165883-DressBerry-Women-Flats-2831590467165015-1.jpg',
  },
  {
    id: 41,
    name: `ZAPATOZ Women White Sneakers`,
    price: 999,
    category: 'footwear',
    quantity: 1,
    rating: '3.9',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11812038/2020/4/27/cd8f97ad-3b01-4178-ab54-bee0a962de0e1587965336877ZAPATOZ4.jpg',
  },
  {
    id: 42,
    name: `Crocs Unisex Navy Blue Solid Bayaband Clogs`,
    price: 2979,
    category: 'footwear',
    quantity: 1,
    rating: 4.5,
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11567688/2020/3/20/1f4d4b99-8a35-48af-87da-f966a2c23b5a1584703400474-Crocs-Unisex-Navy-Blue-Sandals-2211584703399157-1.jpg',
  },
  {
    id: 43,
    name: `DressBerry Women Peach-Coloured Solid Flats`,
    price: 799,
    category: 'footwear',
    quantity: 1,
    rating: '3.2',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11564036/2020/5/26/f1f8bbc9-046a-4529-87e2-249a3c033c2c1590467165883-DressBerry-Women-Flats-2831590467165015-1.jpg',
  },
  {
    id: 44,
    name: `ZAPATOZ Women White Sneakers`,
    price: 999,
    category: 'footwear',
    quantity: 1,
    rating: '3.9',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11812038/2020/4/27/cd8f97ad-3b01-4178-ab54-bee0a962de0e1587965336877ZAPATOZ4.jpg',
  },
  {
    id: 45,
    name: `Crocs Unisex Navy Blue Solid Bayaband Clogs`,
    price: 2979,
    category: 'footwear',
    quantity: 1,
    rating: 4.5,
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11567688/2020/3/20/1f4d4b99-8a35-48af-87da-f966a2c23b5a1584703400474-Crocs-Unisex-Navy-Blue-Sandals-2211584703399157-1.jpg',
  },
  {
    id: 46,
    name: `DressBerry Women Peach-Coloured Solid Flats`,
    price: 799,
    category: 'footwear',
    quantity: 1,
    rating: '3.2',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11564036/2020/5/26/f1f8bbc9-046a-4529-87e2-249a3c033c2c1590467165883-DressBerry-Women-Flats-2831590467165015-1.jpg',
  },
  {
    id: 47,
    name: `ZAPATOZ Women White Sneakers`,
    price: 999,
    category: 'footwear',
    quantity: 1,
    rating: '3.9',
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11812038/2020/4/27/cd8f97ad-3b01-4178-ab54-bee0a962de0e1587965336877ZAPATOZ4.jpg',
  },
  {
    id: 48,
    name: `Crocs Unisex Navy Blue Solid Bayaband Clogs`,
    price: 2979,
    category: 'footwear',
    quantity: 1,
    rating: 4.5,
    imageUrl:
      'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11567688/2020/3/20/1f4d4b99-8a35-48af-87da-f966a2c23b5a1584703400474-Crocs-Unisex-Navy-Blue-Sandals-2211584703399157-1.jpg',
  },
];

const ALL_PRODUCTS = new Array().concat(
  ACCESSORIES,
  FOOTWEAR,
  CASUAL_WEAR,
  PARTY_WEAR
);

const FAKEDATA = {
  FEATURED_PRODUCTS: FEATURED_PRODUCTS,
  PARTY_WEAR: PARTY_WEAR,
  CASUAL_WEAR: CASUAL_WEAR,
  FOOTWEAR: FOOTWEAR,
  ACCESSORIES: ACCESSORIES,
  ALL_PRODUCTS: ALL_PRODUCTS,
};

export default FAKEDATA;
